module.exports = __webpack_public_path__ + "img/EnglishRegisterPage.d6685df1.jpg";